import { isValidJSON } from "../../../Dashboard/utility/itemsUtility";
import * as type from "../../types/API/buyerSupplier";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
  bulkUploadSuccess: '',
  bulkUploadErrorData: [],
  message: ''
};

export const buyerSupplierReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BUYER_SUPPLIER:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BUYER_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BUYER_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addBuyerSupplierReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_BUYER_SUPPLIER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_BUYER_SUPPLIER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_BUYER_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editBuyerSupplierReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.EDIT_BUYER_SUPPLIER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_BUYER_SUPPLIER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_BUYER_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBuyerSupplierReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_BUYER_SUPPLIER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BUYER_SUPPLIER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BUYER_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const bulkDeleteBuyerSupplierReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.BULK_DELETE_BUYER_SUPPLIER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.BULK_DELETE_BUYER_SUPPLIER_SUCCESS:
      return {
        error: null,
        loading: false,
        bulkUploadErrorData: null,
        data: action.payload.responseData,
      };
    case type.BULK_DELETE_BUYER_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const bulkUploadBuyerSupplierReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.BULK_UPLOAD_BUYER_SUPPLIER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.BULK_UPLOAD_BUYER_SUPPLIER_SUCCESS:
      return {
        error: null,
        loading: false,
        bulkUploadSuccess: action?.payload?.responseData?.message || '',
        bulkUploadErrorData: action?.payload?.responseData?.invalidData || []
      };
    case type.BULK_UPLOAD_BUYER_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getCompanyDetailsByGstnReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_COMPANY_DETAILS_BY_GSTN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.GET_COMPANY_DETAILS_BY_GSTN_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action?.payload?.responseData?.data,
        message: action.payload.responseData.message
      };
    case type.GET_COMPANY_DETAILS_BY_GSTN_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.empty ? '' : 'Invalid GSTIN',
      };
    default:
      return state;
  }
};
